/** Shared layout tokens for report pages (spacing, filter bar, sections). */
export const reportPageSx = {
  container: { mt: 2, mb: 2, px: { xs: 1.5, sm: 2 } },
  breadcrumbs: { mb: 1.5 },
  pageHeader: { mb: 2 },
  pageTitle: { fontSize: { xs: '1.35rem', sm: '1.5rem' }, fontWeight: 700 },
  filterCard: {
    mb: 2,
    border: '1px solid',
    borderColor: 'divider',
    boxShadow: 'none',
  },
  filterCardContent: {
    py: 1.5,
    px: 2,
    '&:last-child': { pb: 1.5 },
  },
  filterGrid: { spacing: 1.5 },
  filterButton: { height: 40 },
  metricsGrid: { spacing: 1.5, mb: 2 },
  metricCol: { xs: 6, sm: 4, md: 2 },
  sectionCard: {
    border: '1px solid',
    borderColor: 'divider',
    boxShadow: 'none',
  },
  sectionCardContent: {
    py: 1.5,
    px: 2,
    '&:last-child': { pb: 1.5 },
  },
  sectionTitle: { fontSize: '1rem', fontWeight: 600, mb: 1 },
};
